import { Telemetry } from '@ctw/shared/context/telemetry/index';
import { useEffect } from 'react';
import { computeCanonicalRumViewName } from './canonical-view-name';

// Reports a canonical DataDog RUM view name whenever the given pathname changes.
// Apps pass their router's current pathname (e.g. React Router's
// useLocation().pathname, or Next.js's usePathname()); pathnames that
// computeCanonicalRumViewName doesn't recognize report `null`, so Telemetry
// discards any pending override rather than applying a stale name to this view
// once init completes. Kept framework-agnostic (a plain string in) so the zap-iframe,
// smart-on-fhir, and standalone apps can all share it.
export const useReportCanonicalRumViewName = (pathname: string): void => {
  useEffect(() => {
    Telemetry.setViewName(computeCanonicalRumViewName(pathname));
  }, [pathname]);
};
